const RadioButton = ({ text, id, name, value, checked, OnChange, className }) => {
    return (
        <div className={`radio ${checked ? "checked" : ""} ${className ? className : ""}`}>
            <input id={id} type="radio" checked={checked} value={value} name={name} onChange={OnChange} />
            <label htmlFor={id}>{text}</label>
        </div>
    );
};

export default RadioButton;
